import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { PostalAddress } from '../../../common/model/postal-address';
import { MessageService } from '../../../core/service/message.service';
import { Profile } from '../../model/profile';
import { ProfileManagementService } from '../../service/data/profile-management.service';
import { FormControlExFactory } from './../../../core/service/factory/form-control-ex-factory.service';

// "Licensuppgifter"
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProfileComponent implements OnInit {
  constructor(
    private _cf: FormControlExFactory,
    private _fb: FormBuilder,
    private _service: ProfileManagementService,
    private _messageService: MessageService
  ) {}

  private _dataContext: Profile;
  address: PostalAddress;

  form: FormGroup;

  private _getFormGroup(): FormGroup {
    return this._fb.group({
      address: this._fb.group({}),
      name: this._cf.createWithOptions('PROFILE_FORM.NAME_LABEL', this._dataContext.name, { length: 50, required: true }),
      email: this._cf.createWithOptions('PROFILE_FORM.EMAIL_LABEL', this._dataContext.email, { length: 255, required: true }),
      referenceName: this._cf.createWithOptions('PROFILE_FORM.REFERENCE_NAME_LABEL', this._dataContext.referenceName, {
        length: 50,
        required: true,
      }),
      organizationNo: this._cf.createMandatory('PROFILE_FORM.ORGANIZATION_NUMBER_LABEL', this._dataContext.organizationNo),
      phone: this._cf.createWithOptions('PROFILE_FORM.PHONE_LABEL', this._dataContext.phone, { length: 20, required: true }),
      hogiaCustomerNumber: this._cf.createReadonly('LANDLORD.CUSTOMER_NUMBER', this._dataContext.hogiaCustomerNumber),
    });
  }

  private _getReferenceName(): AbstractControl {
    return this.form.controls['referenceName'];
  }

  private _getOrganizationNo(): AbstractControl {
    if (this.form) return this.form.controls['organizationNo'];
  }

  ngOnInit(): void {
    this._service.get().subscribe(
      data => {
        if (data) {
          this._dataContext = data;
          this.address = this._dataContext.address;

          this.form = this._getFormGroup();
        }
      },
      error => this._messageService.showError(error)
    );
  }

  onSubmit() {
    if (this.form.invalid || this.form.pristine) return;

    this._service.change(this.form.value).subscribe(
      () => {
        this._messageService.showSuccess();
      },
      error => this._messageService.showError(error)
    );
  }
}
